<template>
<div class="guide-common-content">
    <div class="g-common-frames">
        <div class="dzhkfs-frames subjectActivity-frames">
            <!-- <div class="dzhkfs-bg"></div> -->
            <div class="dzhkfs-frames-content">
                <div class="dzhkfs-frames-item">
                    <div class="dzhkfs-item-left">
                        <img src="@/assets/images/jy85-xcb-icon-1@2x.png" alt />
                    </div>
                    <div class="dzhkfs-item-right">
                        <h3>加油8.5折 全年返利</h3>
                        <p>鑫驰白金卡中石化加油充值<span>8.5折</span>，全年最高返利<span>3600元</span>！</p>                        
                    </div>
                </div>

                <div class="dzhkfs-frames-item">
                    <div class="dzhkfs-item-left">
                        <img src="@/assets/images/jy85-xcb-icon-2@2x.png" alt />
                    </div>
                    <div class="dzhkfs-item-right">
                        <h3>活动时间</h3>
                        <p>即日起至2021年12月31日</p>                        
                    </div>
                </div>

                <div class="dzhkfs-frames-item">
                    <div class="dzhkfs-item-left">
                        <img src="@/assets/images/jy85-xcb-icon-3@2x.png" alt />
                    </div>
                    <div class="dzhkfs-item-right">
                        <h3>活动对象</h3>
                        <p>上海地区鑫驰白金卡持卡人</p>
                    </div>
                </div>

                <div class="subjectActivity-frames-item">
                    <div class="subjectActivity-frames-item-block">
                        <div class="subjectActivity-item-left">
                            <img src="@/assets/images/jy85-xcb-icon-4@2x.png" alt />
                        </div>
                        <div class="subjectActivity-item-right">
                            <h3>活动内容</h3>
                            <p>
                               鑫驰白金卡持卡人通过上海农商银行信用卡微信公众号或上海农商银行信用卡APP完成活动注册绑定，并同时满足加油卡充值金额和当月非加油类净消费达标条件后,即可参与中石化<span>10%-15%加油金返还</span>优惠，每月最高返还<span>300元加油金</span>。                           
                            </p>
                        </div>
                    </div>
                    <div class="subjectActivity-item-column">
                        <img src="@/assets/images/jy85-xcb-table.png" alt />
                    </div>
                </div>

                <div class="subjectActivity-frames-item">
                    <h3 class="subjectActivity-title">注意事项</h3>
                    <div class="subjectActivity-details">

                        <p>1、参与活动前，即持卡人充值加油卡前，须通过上海农商银行信用卡微信公众号或上海农商银行信用卡APP，完成注册绑定中石化加油卡，路径如下：
                        <br>（1）微信搜索公众号“上海农商银行信用卡”点击关注并回复“加油”，进入“鑫驰白金卡加油”专属页面并录入加油卡号进行活动注册绑定；或
                        <br>（2）下载“上海农商银行信用卡”APP，访问“全部-生活服务-加油专区”专属页面并录入加油卡号进行活动注册绑定。
                        <br><span style="padding-left:3vw;">（3）绑定加油卡须与参与活动充值的加油卡一致，如需变更改绑加油卡，请通过上述路径进行变更改绑。</span>
                        </p>
                        <p>2、注册绑定或变更改绑成功后，方可使用本人鑫驰白金卡通过活动指定渠道（见细则4）为其注册绑定的本人中石化个人记名单用户加油卡充值，持卡人可通过上海农商银行信用卡微信公众号或上海农商银行信用卡APP自助查询绑定状态，当月非加油类净消费金额和加油返还金额。每位持卡人每月仅可参与活动一次，并默认持卡人享受与其当月非加油净消费金额相对应的折扣。</p>                        
                        <p>3、持卡人如参与银联支付渠道（包含但不限于云闪付、手机闪付、刷卡等）的优惠活动，持卡人当月加油卡刷卡充值金额及非加油类净消费扣除优惠金额后仍须满足达标条件。例如，持卡人参与“当月非加油净消费满2999元、最高返利150元活动”，如同时参与“云闪付中石化油卡充值立减40元”活动，单笔中石化充值金额须达1040元；如同时参与“云闪付支付立减20元”活动，当月非加油净消费金额须满3019元。</p>
                    </div>
                </div>

                <div class="subjectActivity-frames-item">
                    <h3 class="subjectActivity-title">活动细则</h3>

                    <div class="subjectActivity-details">
                        <p>1.本活动仅限上海农商银行鑫驰白金卡个人卡参加。</p>
                        <p>2.本活动仅限持卡人本人在上海地区办理的中石化个人记名单用户加油卡参加，不记名卡、单位卡和个人多用户卡不参与本活动。</p>

                        <div class="other-content" v-show="isShow3">
                            <p>3.参与活动前，即持卡人刷卡充值加油卡前，须通过我行信用卡微信公众号或上海农商银行信用卡APP完成注册绑定中石化加油卡，路径如下：
                                <br>（1）微信搜索公众号“上海农商银行信用卡”点击关注并回复“加油”，进入“鑫驰白金卡加油”专属页面并录入加油卡号进行活动注册绑定。
                                <br>（2）下载“上海农商银行信用卡”APP，访问“全部-生活服务-加油专区”专属页面并录入加油卡号进行活动注册绑定。
                                <br>（3）绑定加油卡须与参与活动充值的加油卡一致，如需变更改绑加油卡，请通过上述路径进行变更改绑。持卡人可通过上海农商银行信用卡微信公众号或上海农商银行信用卡APP自助查询绑定状态、当月非加油类净消费金额和加油返还金额，绑定状态显示成功后，方可参加活动。
                                </p>
                            <p>4.参与活动的持卡人须使用本人鑫驰白金卡在上海地区中石化线下指定充值网点（自助充值机除外）以及中国石化网上营业厅（www.sinopecsales.com）、中国石化APP“加油中石化”，为其本人名下已绑定成功的上海地区发行的中石化个人记名单用户加油卡刷卡充值。充值渠道仅限银联支付渠道（第三方支付渠道除外）。</p>                            
                            <p>5.持卡人当月同时满足加油卡充值达标和非加油类消费达标条件后，可参与相应活动，达标情况可在我行微信公众号和APP上查询。活动奖励将于次月起60个自然日内返还至持卡人注册成功的中石化个人记名单用户加油卡内。如返利期间客户加油卡遗失，可前往中石化网点挂失补卡即可，不会影响活动返利，如须再次参与活动，请优先致电我行客服改绑加油卡。每位持卡人每月仅可参与活动一次，并默认持卡人享受与其当月非加油净消费金额相对应的折扣。优惠返利仅限中石化加油站内持卡消费，不可折现；清户退款时，仅可退回客户充值的本金部分，优惠返利金不可清户退款。</p>

                            <p>6.本活动非加油净消费指一般人民币交易消费（含线上和线下消费），不含取现、还款、分期、预借现金、预授权、银行费用（信用卡年费、信用卡利息、预借现金手续费）等。消费后如发生退货、冲正、争议、虚假、退税或撤销等，将在活动累计消费金额中扣除相应金额，如导致消费金额不达标，将无法参与活动。合格消费须自然月内消费且入账。因时差、商户及收单行结算交易延迟等原因造成的交易不符合活动条件，本行不承担任何责任。</p>

                            <p>7.奖励返还后，符合条件的持卡人须前往中石化加油网点完成“圈存”后方可使用。具体“圈存”操作可咨询中国石化客服热线95105888。</p>

                            <p>8.上述我行指定渠道的中石化充值网点，请详询中国石化上海客服热线95105888/95105999，或登陆中国石化网上营业厅官方网站 http://www.sinopecsales.com/查询。</p>

                            <p>9.本活动注册的个人记名单用户加油卡不可同时参加中石化其他营销活动，如持卡人同时符合我行其他卡种中石化营销活动，我行将默认持卡人参与奖励幅度最大的活动。</p>

                            <p>10.持卡人知晓并同意，上海农商银行有权对持卡人用卡、还款、资信及风险状况进行综合评估。持卡人如有下述任何一种情况，其享受本活动的资格将被取消，包括但不限于当前账户出现欠款逾期、销户、冻结及其他非正常状态；出现所持信用卡过期、被停用、管制、持卡人自行注销信用卡、违反《上海农商银行信用卡章程》及《上海农商银行信用卡（个人卡）领用合约》或本活动细则及相关规定的。</p>

                            <p>11.如持卡人发生任何虚假、欺诈、套现、用于经营性目的等不正常交易，或持卡人存在任何违反《上海农商银行信用卡章程》、《上海农商银行信用卡（个人卡）领用合约》约定的行为，或持卡人账户发生逾期、限制或停止用卡、风险管控、销卡等非正常状态、或持卡人在出现疑似不正常交易但拒绝配合上海农商银行进行调查，或符合本活动条件的交易最终被撤销或退货的，则上海农商银行保留对相关交易进行调查核实、拒绝该持卡人参加本活动的权利。</p>

                            <p>12.如发现持卡人参与活动过程中存在任何利用系统漏洞或规则漏洞、外挂软件、插件等手段或工具套取活动奖励、损害活动规则、扰乱正常活动秩序等行为的，包括但不限于使用外挂获取活动资格、恶意刷单、有偿转赠权益、与商户串通、倒卖活动奖励、冒用他人信息参与活动、进行虚假交易等，上海农商银行有权取消注册用户参加本次活动及获得本活动奖励的资格，并有权取消或收回其因参加本次活动所获的奖励。同时，上海农商银行保留追究其法律责任的权利。若系统漏洞、故障或其他原因致使系统无法正常运行，导致持卡人获得与本活动规则不符的奖励，上海农商银行保留取消或收回注册用户参加本活动所获的回馈和奖励权利。</p>

                            <p>13.在法律许可范围内，上海农商银行有权修订本活动条款及细则（包括但不限于参加资格、消费时间及奖励方式等）、暂停或取消本活动，并经相关途径（如上海农商银行官方网站、对账单、短信、信用卡微信公众号、信用卡APP或各分支网点等）提前公告后生效。活动详情以上海农商银行最新公布内容为准，或咨询24小时客服热线021-962999或4006962999。</p>

                            <p>14.其他未尽事宜，仍受《上海农商银行信用卡章程》、《上海农商银行信用卡（个人卡）领用合约》、监管机构及银行卡组织相关规定约束。
                            </p>
                        </div>
                        <div class="subjectActivity-item-right-bottom">
                            <a href="javascript:;" class="more-rule subject-tjx-rule common-subjectActivity-more" @click="e=>this.changeOther('isShow3')" v-show="!isShow3">展开详情</a>
                            <div class="collect-wrap" v-show="isShow3">
                                <div class="collect-btn" @click="e=>this.changeOther('isShow3')">
                                    <i class="guide-icon"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
export default {
    data() {
        return {
            isShow1: false,
            isShow2: false,
            isShow3: false
        };
    },
    computed: {
        ...mapState(['mirror'])
    },
    mounted(){
        
    },
    methods: {
        goBack() {
            this.$router.back();
        },
        changeOther(name) {
            this[name] = !this[name];
        },
        changeTestLink(type) {
            this.$test(`${type}${this.mirrorStatus ? this.mirrorStatus+1 : ""} a-register-2`);
            this.$router_push(this.mirror.current_link)
        }
    },
};
</script>

<style lang="scss" scoped>
</style>
